import React from 'react'
import {
  Button,
  ComponentColor,
  ComponentSize,
  ButtonShape,
} from '@influxdata/clockface'

import {Marketplace} from 'js/types/marketplace'

interface Props {
  marketplace: Marketplace
  text?: string
  size?: ComponentSize
  color?: ComponentColor
  shape?: ButtonShape
}

const buttonInfo = (marketplace: Marketplace): {link: string; text: string} => {
  switch (marketplace) {
    case 'aws':
      return {
        link: 'https://aws.amazon.com/marketplace/library/',
        text: 'Check My AWS Subscription',
      }
    case 'gcm':
      return {
        link: 'https://console.cloud.google.com/marketplace/yourSolutions',
        text: 'Check My Google Cloud Marketplace Subscription',
      }
    case 'azure':
      return {
        link: 'https://portal.azure.com/#blade/Microsoft_Azure_Billing/SubscriptionsBlade',
        text: 'Check My Azure Marketplace Subscription',
      }
    default:
      return {link: '', text: ''}
  }
}

const MarketplaceSubscriptionLink = ({
  marketplace,
  text,
  size = ComponentSize.Small,
  shape = ButtonShape.Default,
  color = ComponentColor.Primary,
}: Props): JSX.Element => {
  const {link, text: defaultText} = buttonInfo(marketplace)

  const handleClick = () => {
    window.open(link, '_blank')
  }

  return (
    <Button
      shape={shape}
      onClick={handleClick}
      text={text || defaultText}
      color={color}
      size={size}
    />
  )
}

export default MarketplaceSubscriptionLink
